import { ToastContainer } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { get, post } from "../../_services/apiService";
import { useCallback, useEffect, useState } from "react";
import Layout from "./Layout";
import { API_URL } from "../../_services/apiUrl";
import { FaImage, FaVideo, FaFileUpload } from 'react-icons/fa';

const CancelOrder = () => {
    const navigate = useNavigate();
    const actionType = sessionStorage.getItem('actionType');
    const [cancelTypeData, setCancelTypeData] = useState([]);
    const [returnTypeData, setReturnTypeData] = useState([]);
    const { id } = useParams();
    const [cancelTypeId, setCancelTypeId] = useState(null);
    const [cancelDescription, setCancelDescription] = useState('');
    const [returnTypeId, setReturnTypeId] = useState(null);
    const [error, setError] = useState([]);
    const [isFileShow, setIsFileShow] = useState(false);

    const [formData, setFormData] = useState({
        productCancelId: 0,
        orderId: parseInt(id),
        cancelTypeId: 0,
        retrunTypeId: 0,
        remark: '',
        files: [],
        FilePath: '',
        isActive: true,
        createdBy: 0,
    });

    const GetCancelType = useCallback(async () => {
        try {
            const response = await get(API_URL.GetCancelType);
            if (response.isSuccess === 1) {
                const filteredData = response?.data?.filter(item =>
                    item?.actionType?.toLowerCase() === actionType?.toLowerCase()
                );
                setCancelTypeData(filteredData);
            }
        } catch (error) {
            setCancelTypeData([]);
        }
    }, [actionType]);

    const GetRetrunType = useCallback(async () => {
        try {
            const response = await get(API_URL.GetRetrunType);
            if (response.isSuccess === 1) {
                const filteredData = response.data?.filter(item => {
                    const itemTypes = item?.actionType?.split(',').map(type => type.trim().toLowerCase());
                    return itemTypes.includes(actionType?.toLowerCase());
                });
    
                setReturnTypeData(filteredData);
            }
        } catch (error) {
            setReturnTypeData([]);
        }
    }, [actionType]);
      

    useEffect(() => {
        GetCancelType();
        GetRetrunType();
    }, [GetCancelType]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "cancelTypeId") {
            const selectedItem = cancelTypeData.find(item => String(item.cancelTypeId) === value);

            if (selectedItem?.isFile === true) {
                setIsFileShow(true);
            } else {
                setIsFileShow(false);
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const files = e.target.files;
        const filesArray = Array.from(files);
        setFormData({
            ...formData,
            files: filesArray,
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const isConfirmed = window.confirm(`Are you sure you want to ${actionType?.toLowerCase() === 'return' ? 'Return' : actionType?.toLowerCase() === 'cancel' ? 'Cancel' : ''} this order?`);
        if (!isConfirmed) {
            return;
        }

        try {
            const dataToSend = new FormData();
            dataToSend.append('productCancelId', formData.productCancelId);
            dataToSend.append('orderId', formData.orderId);
            dataToSend.append('cancelTypeId', formData.cancelTypeId);
            dataToSend.append('retrunTypeId', formData.retrunTypeId);
            dataToSend.append('remark', formData.remark);
            dataToSend.append('isActive', formData.isActive);
            dataToSend.append('createdBy', formData.createdBy);

            formData.files.forEach((file, index) => {
                dataToSend.append('files', file);
            });

            const response = await post(API_URL?.SaveProductCancel, dataToSend);
            if (response.isSuccess === 200) {
                toast.success("Your order has been canceled!");
                navigate('/your-orders');
                setFormData({
                    productCancelId: 0,
                    orderId: parseInt(id),
                    cancelTypeId: 0,
                    retrunTypeId: 0,
                    remark: '',
                    files: [],
                    FilePath: '',
                    isActive: true,
                    createdBy: 0,
                })
            }
        } catch (error) {
            toast.error("Error canceling order: " + error.message);
        }
    };

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <section className="faqs_main layout_main">
                <div className="container-screen pt-sm-4 pt-2 pb-sm-5 pb-2 d-flex justify-content-center">
                    <div className="col-xl-6 col-md-8 col-sm-10 col-11">
                        <div className="breadcrumb_data pb-4 text-white">
                            <Link to='/your-orders'> {`<<Back`}</Link>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="cancel_order_form">
                                <h5>
                                    Reason for {actionType?.toLowerCase() === 'return' ? 'Return' : actionType?.toLowerCase() === 'cancel' ? 'Cancel' : ''}
                                </h5>
                                {cancelTypeData !== null && (
                                    <select
                                        name="cancelTypeId"
                                        value={formData.cancelTypeId}
                                        onChange={handleChange}
                                        className="form-select"
                                    >
                                        <option value="">Select a reason</option>
                                        {cancelTypeData.map((item, i) => (
                                            <option key={i} value={item.cancelTypeId}>
                                                {item.cancelTypeDescription}
                                            </option>
                                        ))}
                                    </select>
                                )}

                                {isFileShow && (
                                    <div className="mt-4">
                                        <h5>Required Attachments</h5>
                                        <div className="file-upload-container">
                                            <div>
                                                <label htmlFor="filePath" className="file-upload-label text-center">
                                                    <p className="upload-icon mb-1">
                                                        <FaFileUpload size={24} />
                                                    </p>
                                                    <span className="upload-text">Select Images or Videos</span>
                                                    {formData.files.length <= 0 &&
                                                        <p className="mb-0 mt-1 message_info">{`(Upload your images or videos here. Max file size: 5 MB.)`}</p>
                                                    }
                                                </label>
                                                <input
                                                    type="file"
                                                    onChange={handleFileChange}
                                                    className="file-input"
                                                    name="filePath"
                                                    accept="image/*,video/*"
                                                    id="filePath"
                                                    multiple
                                                    style={{ display: 'none' }}
                                                />

                                                {formData.files.length > 0 && (
                                                    <div className="selected-files-count text-center mt-2">
                                                        <p>{formData.files.length} file(s) selected</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <h5 className="mt-4">Preferred Resolution</h5>
                                {returnTypeData !== null && (
                                    <select
                                        name="retrunTypeId"
                                        value={formData.retrunTypeId}
                                        onChange={handleChange}
                                        className="form-select"
                                    >
                                        <option value="">Select a resolution</option>
                                        {returnTypeData.map((item, i) => (
                                            <option key={i} value={item.retrunTypeId}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                )}

                                <div className="cancel_description d-block mt-4">
                                    <h5>Additional Comments</h5>
                                    <div>
                                        <textarea
                                            id="remark"
                                            name="remark"
                                            value={formData.remark}
                                            onChange={handleChange}
                                            placeholder="Enter a description"
                                        />
                                    </div>
                                </div>

                                <button type="submit" className="cancel_order_btn web_buttons mt-2">
                                    Submit
                                </button>
                            </div>
                        </form>
                        <div className="Instructions_section mt-4">
                            <div className="instructions_inner">
                                <h5>Submission Instructions:</h5>
                                <ul>
                                    <li>Fill out this form completely.</li>
                                    <li>Attach any required media evidence.</li>
                                    <li>Submit the form via our website or email it to <a href="mailto:support@gailee.in">support@gailee.in</a></li>
                                </ul>
                                <span><b>Note: </b>Returns will not be processed without the required media evidence.</span>
                            </div>
                            <div className="instructions_inner">
                                <h5>Return Instructions:</h5>
                                <ul>
                                    <li>Ensure the item is in its original condition, with tags and packaging intact.</li>
                                    <li>Pack the item securely and include this form in the return package.</li>
                                    <li>Ship it to the following address: <b>B-15, Sector-A, Mahanagar, Lucknow- 226006</b></li>
                                    <li>Email us the tracking details at <a href="mailto:support@gailee.in">support@gailee.in</a> for faster processing.</li>
                                </ul>
                            </div>
                            <p>For any queries, feel free to contact our customer service at 8756562626 or email us at <a href="mailto:support@gailee.in">support@gailee.in</a></p>
                            <p>We appreciate your cooperation and look forward to assisting you! <b>Gailee Lifestyle</b></p>
                        </div>
                    </div>
                </div>
            </section>
        </Layout >
    )
}

export default CancelOrder;